// ============================================================================
// QUICK ACTION BUTTONS COMPONENT
// Pre-defined action buttons grid for instant insights
// ============================================================================

import React from 'react';

interface QuickActionButtonsProps {
  onActionClick: (actionId: string) => void;
  disabled?: boolean;
}

const QUICK_ACTIONS = [
  { id: 'analyze-balance', label: 'Analyze Balance', icon: '⚖️' },
  { id: 'suggest-prompt', label: 'Suggest Prompt', icon: '💬' },
  { id: 'review-guidance', label: 'Review Guidance', icon: '💡' },
  { id: 'check-requirements', label: 'Check Requirements', icon: '📋' },
  { id: 'assess-progress', label: 'Assess Progress', icon: '🎯' }
];

export function QuickActionButtons({ onActionClick, disabled }: QuickActionButtonsProps) {
  return (
    <div
      style={{
        padding: '16px',
        borderTop: '1px solid #e5e7eb',
        background: '#f9fafb'
      }}
    >
      <div
        style={{
          fontSize: '0.75rem',
          fontWeight: '600',
          color: '#6b7280',
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }}
      >
        Quick Actions
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '8px'
        }}
      >
        {QUICK_ACTIONS.map((action) => (
          <button
            key={action.id}
            onClick={() => onActionClick(action.id)}
            disabled={disabled}
            style={{
              padding: '10px 12px',
              background: disabled ? '#e5e7eb' : 'white',
              border: '2px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '0.8rem',
              color: disabled ? '#9ca3af' : '#052831',
              cursor: disabled ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'all 0.2s',
              fontWeight: '500'
            }}
            onMouseEnter={(e) => {
              if (!disabled) {
                e.currentTarget.style.borderColor = '#00c6c2';
                e.currentTarget.style.background = 'rgba(0,198,194,0.05)';
              }
            }}
            onMouseLeave={(e) => {
              if (!disabled) {
                e.currentTarget.style.borderColor = '#e5e7eb';
                e.currentTarget.style.background = 'white';
              }
            }}
          >
            <span style={{ fontSize: '1rem' }}>{action.icon}</span>
            <span style={{ fontSize: '0.75rem' }}>{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
